import { ApolloClient, NormalizedCacheObject } from 'apollo-boost'
import { ClientBehaviours } from '../../../utils'

import { stores as STORES_QUERY } from '../../../../graphql/Query/Content/Stores.graphql'
import { ResolverProvider } from '../../types'
import { DayOfWeek } from '../../../../generated/graphql'
import { MOCK_DATA } from '../../../data/StoresMocks'

export const processesLowerCase = (param: string) => {
  return param.replace(/\s+/g, '-').toLowerCase()
}

const combineData = (data) => {
  return data.stores.reduce((stores, store) => {
    const { addressLine5, addressLine4 } = store.address
    const formattedValue = processesLowerCase(addressLine5)
    const formattedValue2 = processesLowerCase(addressLine4)

    if (addressLine5 && addressLine4) {
      if (!stores[formattedValue]) {
        stores[formattedValue] = { [formattedValue2]: [store] }
      } else {
        if (!stores[formattedValue][formattedValue2]) {
          stores[formattedValue] = {
            ...stores[formattedValue],
            [formattedValue2]: [store],
          }
        } else {
          stores[formattedValue][formattedValue2].push(store)
        }
      }
    }

    return stores
  }, {})
}

export enum StoresIconType {
  YES = 'YES',
  NO = 'NO',
}

export interface StoresData {
  stores: {
    id: number
    displayName: string
    urlTag: string
    phoneNumber: string
    relativeDistance: number
    openingTimes: {
      day: DayOfWeek
      openingTime: string
      closingTime: string
    }[]
    address: {
      country: string
      addresseeName: string
      addressLine1: string
      addressLine2: string
      addressLine3: string
      addressLine4: string
      addressLine5: string
      postalCode: string
    }
    storeFacility: {
      icon: StoresIconType
      title: string
    }[]
  }
}

export const Stores: ResolverProvider = (
  client: ApolloClient<NormalizedCacheObject>,
  {
    behaviours,
  }: {
    behaviours: ClientBehaviours
  },
) => async (_, args: { region: string; city: string }) => {
  if (behaviours.override) {
    const groupedData = combineData(MOCK_DATA)

    if (args?.region) {
      if (args?.city) {
        return groupedData[args.region][args.city]
      }
      return groupedData[args.region]
    }
    return groupedData
  }

  const { data } = await client.query({
    query: STORES_QUERY,
  })

  const groupedData = combineData(data)
  if (args?.region) {
    if (args?.city) {
      return groupedData[args.region][args.city]
    }
    return groupedData[args.region]
  }
  return groupedData
}
